var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophoneActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.375 15.125C23.375 18.92 20.295 22 16.5 22C12.705 22 9.625 18.92 9.625 15.125H6.875C6.875 19.9787 10.4637 23.9663 15.125 24.64V28.875H17.875V24.64C22.5363 23.9663 26.125 19.9787 26.125 15.125H23.375V15.125Z",
    fill: "#F7AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.25C18.7825 19.25 20.625 17.4075 20.625 15.125V6.875C20.625 4.5925 18.7825 2.75 16.5 2.75C14.2175 2.75 12.375 4.5925 12.375 6.875V15.125C12.375 17.4075 14.2175 19.25 16.5 19.25ZM15.125 6.875C15.125 6.11875 15.7437 5.5 16.5 5.5C17.2563 5.5 17.875 6.11875 17.875 6.875V15.125C17.875 15.8813 17.2563 16.5 16.5 16.5C15.7437 16.5 15.125 15.8813 15.125 15.125V6.875Z",
    fill: "#F7AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.25C18.7825 19.25 20.625 17.4075 20.625 15.125V6.875C20.625 4.5925 18.7825 2.75 16.5 2.75C14.2175 2.75 12.375 4.5925 12.375 6.875V15.125C12.375 17.4075 14.2175 19.25 16.5 19.25Z",
    fill: "#F7AD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneActive);
export default __webpack_public_path__ + "static/media/microphone-active.4606373396e2dbe8934e766ad659a2be.svg";
export { ForwardRef as ReactComponent };